module.exports = __webpack_public_path__ + "img/clients2-479.b2fa632.png";